/* Yuvakart Wishlist - localStorage based, no app required */
(function(){
  if(window.YKWish)return;
  var KEY = 'yk_wishlist';

  function owner(){ return window.YK_OTP && window.YK_OTP.isVerified() || ''; }
  function key(base){ var phone = owner(); return phone ? base + ':' + phone : ''; }
  function get(){ var k=key(KEY); if(!k) return []; try{ var a=JSON.parse(localStorage.getItem(k) || '[]'); return Array.isArray(a) ? a.filter(function(h){return typeof h === 'string';}) : []; }catch(e){ return []; } }
  function saveA(a){ var k=key(KEY); if(!k) return; try{ localStorage.setItem(k, JSON.stringify(a)); }catch(e){} updateCount(); }
  var REMOVED = 'yk_wishlist_removed';
  function removed(){ var k=key(REMOVED); if(!k)return []; try{ return JSON.parse(localStorage.getItem(k) || '[]'); }catch(e){ return []; } }
  function markRemoved(handles){
    try {
      var set = removed();
      handles.forEach(function(h){ if(set.indexOf(h) === -1) set.push(h); });
      localStorage.setItem(key(REMOVED), JSON.stringify(set));
    } catch(e){}
  }
  function unmarkRemoved(h){
    try{ localStorage.setItem(key(REMOVED), JSON.stringify(removed().filter(function(x){ return x !== h; }))); }catch(e){}
  }
  function removeMany(handles){
    var selected = get().filter(function(h){ return handles.indexOf(h) !== -1; });
    if(!selected.length) return [];
    saveA(get().filter(function(h){ return handles.indexOf(h) === -1; }));
    markRemoved(selected);
    window.dispatchEvent(new CustomEvent('yk:wishlist-removed', {detail:{handles:selected}}));
    return selected;
  }
  function has(h){ return get().indexOf(h) > -1; }
  function toggle(h){
    if(!owner() || typeof h !== 'string' || !h) return false;
    var a = get(); var i = a.indexOf(h);
    if(i > -1){ a.splice(i,1); markRemoved([h]); } else { a.push(h); unmarkRemoved(h); }
    saveA(a);
    window.dispatchEvent(new CustomEvent('yk:wishlist-changed', {detail:{handle:h,added:i === -1}}));
    return i === -1;
  }
  function count(){ return get().length; }

  function updateCount(){
    var n = count();
    var els = document.querySelectorAll('.yk-wishcount');
    for(var i=0;i<els.length;i++){
      if(els[i].textContent !== String(n))els[i].textContent = n;
      var display=n > 0 ? '' : 'none'; if(els[i].style.display!==display)els[i].style.display=display;
    }
  }

  var HEART = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 1 0-7.7 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8z"/></svg>';

  function injectCSS(){
    if(document.getElementById('yk-wish-css')) return;
    var s = document.createElement('style');
    s.id = 'yk-wish-css';
    s.textContent = [
      '.card-wrapper,.card,.grid__item{position:relative}',
      '.yk-heart{position:absolute;top:10px;right:10px;z-index:30;width:38px;height:38px;border-radius:50%;border:none;background:rgba(255,255,255,.96);display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 3px 12px rgba(40,25,10,.2);transition:transform .2s ease,background .2s ease;pointer-events:auto}',
      '.yk-heart:hover{transform:scale(1.12)}',
      '.yk-heart svg{width:19px;height:19px;fill:none;stroke:#b8383b;stroke-width:1.8px;transition:fill .2s ease}',
      '.yk-heart.on svg{fill:#b8383b;stroke:#b8383b}',
      '.yk-wish .yk-wishcount[hidden]{display:none}',
      '.yk-actions .yk-action small,.header__icons .yk-action small{min-width:41px;text-align:center}',
      '.yk-actions > a.yk-action:has(small){padding-left:2px;padding-right:2px}',
      '.yk-actions:has(.yk-wish){column-gap:2px}',
      '.yk-actions .yk-action .yk-count{left:calc(50% + 1px);right:auto}',
      '.yk-pdp-wish{display:inline-flex;align-items:center;gap:9px;justify-content:center;width:100%;margin-top:10px;padding:12px 16px;border-radius:30px;border:1.5px solid #e2c98f;background:#fff;color:#7a4a12;font-weight:700;font-size:13.5px;letter-spacing:.02em;cursor:pointer;transition:all .2s ease}',
      '.yk-pdp-wish:hover{background:#fff8ea;border-color:#d9a441}',
      '.yk-pdp-wish.on{background:#fff2f2;border-color:#e7b7b7;color:#b8383b}',
      '.yk-pdp-wish svg{width:19px;height:19px;fill:none;stroke:currentColor;stroke-width:1.8px}',
      '.yk-pdp-wish.on svg{fill:#b8383b;stroke:#b8383b}'
    ].join('');
    document.head.appendChild(s);
  }

  function handleFrom(card){
    var link = card.querySelector('a[href*="/products/"]');
    if(!link) return null;
    var href = link.getAttribute('href') || '';
    var p = href.split('/products/')[1];
    if(!p) return null;
    p = p.split('?')[0];
    p = p.split('/')[0];
    p = p.split('#')[0];
    return p || null;
  }

  function cards(){
    var wraps = document.querySelectorAll('.card-wrapper');
    for(var i=0;i<wraps.length;i++){
      var card = wraps[i];
      if(card.getAttribute('data-yk-heart')) continue;
      var h = handleFrom(card);
      if(!h) continue;
      card.setAttribute('data-yk-heart','1');
      if(getComputedStyle(card).position === 'static'){ card.style.position = 'relative'; }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'yk-heart' + (has(h) ? ' on' : '');
      btn.setAttribute('aria-label','Save to wishlist');
      btn.setAttribute('data-handle', h);
      btn.innerHTML = HEART;
      btn.addEventListener('click', function(ev){
        ev.preventDefault(); ev.stopPropagation();
        var hh = this.getAttribute('data-handle');
        var on = toggle(hh);
        if(on){ this.classList.add('on'); } else { this.classList.remove('on'); }
      });
      card.appendChild(btn);
    }
  }

  function pdp(){
    var forms = document.querySelectorAll('product-form form, form[action*="/cart/add"], form[id^="ppform-"]');
    for(var i=0;i<forms.length;i++){
      var form = forms[i];
      if(form.getAttribute('data-yk-wish')) continue;
      var path = window.location.pathname || '';
      if(path.indexOf('/products/') === -1) continue;
      form.setAttribute('data-yk-wish','1');
      var h = path.split('/products/')[1];
      if(!h) continue;
      h = h.split('?')[0].split('/')[0].split('#')[0];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'yk-pdp-wish' + (has(h) ? ' on' : '');
      b.setAttribute('data-handle', h);
      b.innerHTML = HEART + '<span class="yk-pdp-wish__t">' + (has(h) ? 'Saved to Wishlist' : 'Add to Wishlist') + '</span>';
      b.addEventListener('click', function(){
        var hh = this.getAttribute('data-handle');
        var on = toggle(hh);
        var t = this.querySelector('.yk-pdp-wish__t');
        if(on){ this.classList.add('on'); if(t){ t.textContent = 'Saved to Wishlist'; } }
        else { this.classList.remove('on'); if(t){ t.textContent = 'Add to Wishlist'; } }
      });
      form.appendChild(b);
    }
  }

  var HEART_PATH = 'M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 1 0-7.7 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8z';
  function header(){
    var bars = document.querySelectorAll('.yk-actions, .header__icons, .header-actions');
    for(var i=0;i<bars.length;i++){
      var bar = bars[i];
      if(bar.querySelector('.yk-wish')) continue;
      var cart = bar.querySelector('a[href*="/cart"], .yk-action--cart, [href$="/cart"]');
      var labelTag = 'small';
      var badgeCls = 'yk-count';
      var actionCls = 'yk-action';
      var cartSvg = null;
      if(cart){
        if(cart.className){ actionCls = (cart.className.baseVal !== undefined ? cart.className.baseVal : cart.className); }
        var lbl = cart.querySelector('small, .yk-action__label, .yk-action__text');
        if(lbl){ labelTag = lbl.tagName.toLowerCase(); }
        var bdg = cart.querySelector('.yk-count, [class*="count"]');
        if(bdg && bdg.className){ badgeCls = (bdg.className.baseVal !== undefined ? bdg.className.baseVal : bdg.className); }
        cartSvg = cart.querySelector('svg');
      }
      var a = document.createElement('a');
      a.href = '/pages/wishlist';
      a.setAttribute('aria-label','Wishlist');
      a.className = actionCls + ' yk-wish';

      var svg;
      if(cartSvg){
        svg = cartSvg.cloneNode(false);
        svg.setAttribute('viewBox','0 0 24 24');
        svg.removeAttribute('id');
      } else {
        svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
        svg.setAttribute('viewBox','0 0 24 24');
        svg.setAttribute('width','22');
        svg.setAttribute('height','22');
      }
      svg.innerHTML = '<path d="' + HEART_PATH + '"></path>';

      var label = document.createElement(labelTag);
      label.textContent = 'Wishlist';

      var badge = document.createElement('span');
      badge.className = badgeCls + ' yk-wishcount';
      badge.textContent = '0';

      a.appendChild(svg);
      a.appendChild(label);
      a.appendChild(badge);

      if(cart && cart.parentNode === bar){ bar.insertBefore(a, cart); }
      else { bar.appendChild(a); }
    }
    updateCount();
  }

  function run(){
    injectCSS();
    header();
    cards();
    pdp();
    updateCount();
    document.querySelectorAll('.yk-heart[data-handle],.yk-pdp-wish[data-handle]').forEach(function(b){
      var on=has(b.getAttribute('data-handle'));
      if(b.classList.contains('on') !== on)b.classList.toggle('on',on);
      var t=b.querySelector('.yk-pdp-wish__t'),text=on?'Saved to Wishlist':'Add to Wishlist';
      if(t && t.textContent !== text)t.textContent=text;
    });
  }
  document.addEventListener('yk:otp-verified',run);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)run();});
  window.addEventListener('pageshow',run);
  setInterval(function(){if(!document.hidden)run();},60000);

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }

  var t = null;
  var obs = new MutationObserver(function(){
    if(t) return;
    t = setTimeout(function(){ t = null; run(); }, 300);
  });
  try{ obs.observe(document.body, {childList:true, subtree:true}); }catch(e){}

  window.YKWish = { get:get, has:has, toggle:toggle, count:count, removeMany:removeMany, removed:removed };
})();